import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { useEffect } from "react";
import { useAppDispatch } from "./hooks";
import { useNavigate } from "react-router-dom";
import { setToast } from "../app/appSlice";




export const useRedirect404 = (error:FetchBaseQueryError | SerializedError | undefined, path:string) => {

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if(error) {
            if (error && (error as any).status === 404) {
                dispatch(
                    setToast({
                      content: "Vous n'avez pas les droits suffisants pour travailler sur ce traitement.",
                      life: 6000,
                      severity: "error",
                    })
                  );
                navigate(`/${path}`);
            }
        }
    },[error])


}